import React from 'react';
import axios from "axios";
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash, faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';

import { useState, useEffect, useMemo } from 'react';

const Season = () => {
    const [value, setvalue] = useState("");
    const [flag, setFlag] = useState(false);
    const [seasonData, setSeasonsData] = useState([]);
    const [seasonValue, setSeasonValue] = useState("");
    const [deleteCode, setDeleteCode] = useState({});
    const [editCode, setEditCode] = useState("");

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/seasons`);
        setSeasonsData(result.data.dataContent);
    };

    useEffect(() => {
        if (flag == true) {
            fetchData()
        }
    }, [flag])

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'seasonName',
                header: 'Season Name',
            },
            {
                accessorKey: 'visibility',
                header: 'Visibility',
            },
            {
                accessor: '',
                header: 'Actions',
                Cell: cell => <>
                    <i className="btn text-primary" type="button" onClick={() => handleEditSeason(cell.row.original)}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#myDelete" onClick={() => setDeleteCode({ "SeasonCode": cell.row.original.seasonCode })}> <FontAwesomeIcon icon={faTrashAlt} /></i></>

            },

        ],
        [],
    );

    function removed() {
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "none";
       setSeasonValue("");

    }

    function removedAdd() {
        var mpopup = document.getElementById('myAdd');
        mpopup.style.display = "none";
       setSeasonValue("");

    }

    function handleEditSeason(value) {

 document.getElementById("seasonEdit").value = value.seasonName;

        setEditCode({ "SeasonCode": value.seasonCode, "SeasonName": value.seasonName })
        
        var x = document.createElement("a")
        x.id = "mpopupLink";
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "block";
    }

    function AddNewSeason() {
  if (seasonValue) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "SeasonName": seasonValue,
            "Visibility": "Y",
            "CreatedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/seasons`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    removedAdd()
                   
                }

            })
            .catch(error => console.log('error', error));
} else {
      alert("Enter Season Name");
    }

    }

    function deleteData(value) {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/seasons`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success == true) {
                    fetchData()

                }
            })
            .catch(error => console.log('error', error));
    }

    function EditSeason() {
        if (seasonValue) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "SeasonCode": editCode.SeasonCode,
            "SeasonName": seasonValue,
            "Visibility": "Y",
            "ModifiedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/seasons`, requestOptions)
            .then(response => response.text())
            .then(result => {alert(JSON.parse(result).message)
                if (JSON.parse(result).success == true) {
                    fetchData()
                    removed()

        }
    }
            )
            .catch(error => console.log('error', error));
        } else {
            alert("Enter Season Name");
          }
    }

    function handleAddNewData() {
        setSeasonValue("");
        setFlag(false)
      }

      function handleSeasonsValue(value) {
        console.log("value@@", value)
        const valueFinal = value.replace(/[^a-z0-9 ]/gi, "");
        document.getElementById("seasonEdit").value = valueFinal;
        setSeasonValue(valueFinal)
    }

    return (
        <>
           
            <main id="main" className="main">

                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Seasons</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Master</li>
                            <li className="breadcrumb-item active">Seasons</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" data-bs-toggle="modal" data-bs-target="#myAdd" onClick={() => handleAddNewData() }>Add New</button>
                </div>
                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={seasonData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                />

                            </div>

                        </div>

                    </div>
                </section>

            </main>
            <div className="modal" id="myAdd">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                        <label for="add_season" className="form-label">Add New Season</label>
                            <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                        </div>

                        <div className="modal-body">
                           
                            <input type="text" className="form-control" placeholder="Add New Season" value ={seasonValue}   maxLength={50} onChange={(e) => handleSeasonsValue(e.target.value)}  />
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" onClick={AddNewSeason}>Add</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
         

            <div id="mpopupBox" className="modal">

                <div className="modal-content" >
                    <div className="modal-header">
                        <h2>View Details</h2>
                    </div>
                    <div className="madal-body" id="modal-content" >
                        <label for="edit_season" className="form-label">Edit Season</label>
                        <input type="text" className="form-control" placeholder="Add New Season" id="seasonEdit"   maxLength={50} onChange={(e) => handleSeasonsValue(e.target.value)} />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={EditSeason}>Add</button>
                        <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={removed}>Close</button>
                    </div>
                </div>

            </div>

            <div className="modal" id="myDelete">
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                        </div>

                        <div className="modal-body">
                            <p>Are you sure you want to delete this item?</p>
                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
           
        </>
    )
}

export default Season;

